import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import Form from '../../components/Form/Form';
import { ROLE_LIST, ROLE_PHYSICIAN } from '../../constants/roles';


const fields = [
  {
    id: 'firstName',
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
  {
    id: 'lastName',
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
  {
    id: 'email',
    name: 'email',
    label: 'Email',
    type: 'email',
    validateAs: 'string',
    defaultVal: '',
    disabled: false,
    required: true,
  },
  {
    id: 'role',
    name: 'role',
    label: 'Role',
    type: 'select',
    placeholder: 'Select a role',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
];

const extraFields = [
  {
    id: 'optionalEmail1',
    name: 'optionalEmail1',
    label: 'Optional Email 1',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail2',
    name: 'optionalEmail2',
    label: 'Optional Email 2',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail3',
    name: 'optionalEmail3',
    label: 'Optional Email 3',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail4',
    name: 'optionalEmail4',
    label: 'Optional Email 4',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail5',
    name: 'optionalEmail5',
    label: 'Optional Email 5',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
];

const propTypes = {
  user: PropTypes.oneOfType([PropTypes.object]),
  onSubmit: PropTypes.func.isRequired,
  reset: PropTypes.bool,
  userStore: mobxPropTypes.observableObject.isRequired,
  snackbarStore: mobxPropTypes.observableObject.isRequired,
};

const defaultProps = {
  user: {},
  reset: false,
};

class UserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isResetting: false,
      role: null,
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.populateFields = this.populateFields.bind(this);
  }

  componentWillMount() {
    const { user } = this.props;
    if (user.role) {
      this.setState({ role: user.role });
    }
  }

  async handleChangePassword() {
    const {
      user,
      userStore,
      loadingStore,
      snackbarStore,
    } = this.props;

    loadingStore.setReady(false);
    this.setState({ isResetting: true });

    try {
      await userStore.api.users.requestResetPassword(user.id);

      this.setState({ isResetting: false });
      snackbarStore.setSuccess({
        title: 'An email has been sent to the user to reset the password.',
      });
    } catch (error) {
      this.setState({ isResetting: false });
      snackbarStore.setError({
        title: `Sorry, an error occurred.${error.errors ? ' Please correct the errors below:' : ''}`,
        duration: null,
        messages: error.errors ? error.errors : null,
      });
    }
    loadingStore.setReady(true);
  }

  handleRoleChange(role) {
    this.setState({ role });
  }

  populateFields(user, fieldsList) {
    const data = {
      firstName: { defaultVal: user.first_name || '' },
      lastName: { defaultVal: user.last_name || '' },
      email: { defaultVal: user.email || '' },
      role: {
        defaultVal: user.role || '',
        customProps: {
          inputProps: {
            name: 'role',
            id: 'role',
          },
          data: ROLE_LIST,
          onChange: this.handleRoleChange,
        },
      },
      optionalEmail1: { defaultVal: user.optional_email_one || '' },
      optionalEmail2: { defaultVal: user.optional_email_two || '' },
      optionalEmail3: { defaultVal: user.optional_email_three || '' },
      optionalEmail4: { defaultVal: user.optional_email_four || '' },
      optionalEmail5: { defaultVal: user.optional_email_five || '' },
    };

    const populatedFileds = fieldsList.map(field => (
      { ...field, ...data[field.name] }
    ));
    return populatedFileds;
  }

  render() {
    const { user, reset, onSubmit } = this.props;
    const { role, isResetting } = this.state;

    let currentFields = fields;
    if (role === ROLE_PHYSICIAN) {
      currentFields = fields.concat(extraFields);
    } else {
      currentFields = fields;
    }
    const populatedFields = this.populateFields(user, currentFields);

    return (
      <Form
        fields={populatedFields}
        onSubmit={async (values, { setSubmitting }) => {
          await onSubmit(values, setSubmitting);
        }}
        onReset={this.handleChangePassword}
        reset={reset}
        isResetting={isResetting}
        submitLabel="Submit"
        resetLabel="Change Password"
        columns={2}
        spacing={32}
      />
    );
  }
}

UserForm.propTypes = propTypes;
UserForm.defaultProps = defaultProps;
export default inject('userStore', 'loadingStore', 'snackbarStore')(observer(UserForm));



// WEBPACK FOOTER //
// ./src/containers/UserForm/UserForm.js